var paragraph_default = {
  "fontElementMap": "euUB4",
  "elementSpacing": "Ntato",
  "text": "aMozl Ntato",
  "child": "QYU6V"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
